import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/utils/guards/auth.guard';

// export const routes: Routes = [
//   {
//     path: '',
//     loadChildren: () =>
//       import('./main/frontoffice/frontoffice.module').then(
//         (m) => m.FrontofficeModule
//       ),
//   },
//   {
//     path: 'admin',
//     loadChildren: () =>
//       import('./main/backoffice/backoffice.module').then(
//         (m) => m.BackofficeModule
//       ),
//   },
// ];

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./main/frontoffice/frontoffice.module').then(
        (m) => m.FrontofficeModule
      ),
  },

  {
    path: 'admin/login',
    loadChildren: () =>
      import('./shared/modules/auth/auth.module').then((m) => m.AuthModule),
  },

  {
    path: 'admin',
    canLoad: [AuthGuard],
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./main/backoffice/backoffice.module').then(
        (m) => m.BackofficeModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
